export default [
  '(min-width: 992px)',
  '(min-width: 768px)',
  '(min-width: 480px)',
  '(max-width: 480px)',
]
